import { TelemetryBar, TelemetryBarParams } from '@shared/interfaces/telemetry';
import { getSeriesColor } from '../../../../utils/color/color';
import { ChartOptions } from 'chart.js';

export const createBar = (graph: TelemetryBar) => {
  return {
    type: 'bar' as const,
    title: graph.title,
    options: createOptions(graph.params),
    data: buildChartData(graph.data),
    height: 400,
    plugins: [],
  };
};

const buildChartData = (data: TelemetryBar['data']) => {
  const dataValues = data.map((el) => el.count);
  const indexName = Object.keys(data[0] || '').filter((name) => name !== 'count')[0];
  const dataKeys = data.map((el) => el[indexName]);
  return {
    datasets: [
      {
        data: dataValues,
        backgroundColor: dataValues.map((_, i) => getSeriesColor(i)),
      },
    ],
    labels: dataKeys,
  };
};

export const createOptions = (options: TelemetryBarParams): ChartOptions<'bar'> => {
  return {
    maintainAspectRatio: false,
    responsive: true,
    animation: false,
    scales: {
      x: {
        title: { text: options.labels[options.x], display: true, font: { weight: 'bold' } },
      },
      y: {
        title: { text: options.labels[options.y], display: true, font: { weight: 'bold' } },
      },
    },
    plugins: {
      legend: { display: false },
    },
  };
};
